import { Link } from "react-router-dom";
import { AlertTriangle, Clock, CreditCard } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

// Persistent banner shown when:
//   - subscription is "lapsed"   → red, "Renew now" CTA
//   - subscription is "trial"   AND days_remaining <= 7 → amber, soft warning
// Renders nothing when sponsored/active/trial-with->7-days.
export default function SubscriptionBanner() {
  const { subscription } = useAuth();
  if (!subscription) return null;
  const { status, days_remaining } = subscription;
  if (status === "active" || status === "sponsored") return null;
  if (status === "trial" && days_remaining > 7) return null;

  const lapsed = status === "lapsed";
  return (
    <div
      className={`px-4 sm:px-6 py-2.5 flex flex-wrap items-center gap-3 ${
        lapsed
          ? "bg-destructive/15 text-destructive border-b-2 border-destructive/30"
          : "bg-amber-100 text-amber-900 border-b-2 border-amber-300 dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/30"
      }`}
      data-testid="subscription-banner"
    >
      {lapsed
        ? <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        : <Clock className="w-4 h-4 flex-shrink-0" />}
      <span className="text-sm font-bold flex-1 min-w-0">
        {lapsed
          ? "Your subscription has lapsed. Timesheets and invoices are read-only until you renew."
          : `Your free trial ends in ${days_remaining} day${days_remaining === 1 ? "" : "s"}. Subscribe to keep editing timesheets and invoices.`}
      </span>
      <Link to="/subscription"
            className="rounded-full bg-foreground text-background px-4 py-1.5 text-xs font-extrabold uppercase tracking-wider hover:opacity-90 transition flex items-center gap-1.5"
            data-testid="subscription-banner-cta">
        <CreditCard className="w-3 h-3" /> {lapsed ? "Renew now" : "Subscribe"}
      </Link>
    </div>
  );
}
